'use client';
import React from 'react';

import { type SwapUpsell } from '@/utils/shopify/types/swapUpsell';

import AcneMultiRxUpsell from './components/acneMultiRxUpsell';

const ClientContainer = ({ swapUpsell }: { swapUpsell: SwapUpsell }) => {
  const UpsellComponent = {
    'Acne Multi Rx Upsell': AcneMultiRxUpsell,
  }[swapUpsell.component.value];

  return <UpsellComponent swapUpsell={swapUpsell} />;
};

export default ClientContainer;
